import { Component, Input } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'confirm-assign-component',
  templateUrl: './confirm-assign.component.html',
  styleUrls: ['./confirm-assign.component.scss'],
})
export class ConfirmAssignComponent {
  @Input() public data: any;
  public title: string;
  public confirmTitle: string;

  constructor(
    public modalsService: ModalsService,
    public sharedService: SharedService,
    public ga: GoogleAnalyticsService
  ) {}

  ngOnChanges($event: any) {
    this.data = $event.data.currentValue;
    switch (this.data.type) {
      case 'supply':
        this.title = this.data.state ? 'CONFIRM_SELECT_ALL_SUPPLY' : 'CONFIRM_UNSELECT_ALL_SUPPLY';
        break;
      case 'demand':
        this.title = this.data.state ? 'CONFIRM_SELECT_ALL_DEMAND' : 'CONFIRM_UNSELECT_ALL_DEMAND';
        break;
      default:
        this.title = this.data.state ? 'CONFIRM_SELECT_ALL_ITEMS' : 'CONFIRM_UNSELECT_ALL_ITEMS';
    }
    this.confirmTitle = this.data.state ? 'SELECT' : 'UNSELECT';
  }

  confirm() {
    this.sharedService.sendMessage('GRID_SELECTION_CHANGE_CONFIRM');
    this.modalsService.hideModal();
  }
}
